import { useFormContext } from 'react-hook-form';
import { Content, useContent } from 'src/contexts/ContentContext';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { Stack } from 'src/core/ui';
import {
  COMP_ROWOFFSET_MODE_DESCRIPTION_TO_CID,
  COMP_ROWOFFSET_MODE_TO_CID,
} from 'src/utils/constants/contentIdMaps';
import { CompRowOffsetMode } from 'src/WebApiController';

import * as styles from './AutoPricingCompRowOffsetModeSelector.css';

export const AutoPricingCompRowOffsetModeSelector = ({
  disabled,
}: {
  disabled: boolean;
}) => {
  const { watch, setValue } = useFormContext<{
    compRowOffsetMode: CompRowOffsetMode;
  }>();

  const compRowOffsetMode = watch('compRowOffsetMode');

  const rowOffsetModeDescriptionText = useContent(
    COMP_ROWOFFSET_MODE_DESCRIPTION_TO_CID[compRowOffsetMode]
  );

  return (
    <Stack direction="row" gap="m" alignItems="center">
      <PosEnumSelect
        className={styles.rowOffsetModeSelector}
        disabled={disabled}
        value={compRowOffsetMode}
        valueOptionsContent={COMP_ROWOFFSET_MODE_TO_CID}
        onClick={(e) => e.stopPropagation()}
        onChange={(v) => setValue('compRowOffsetMode', v as CompRowOffsetMode)}
      />
      <div
        title={rowOffsetModeDescriptionText}
        className={styles.rowOffsetModeDescription}
      >
        {rowOffsetModeDescriptionText}
      </div>
    </Stack>
  );
};
